import { render, staticRenderFns } from "./ViewConsumptionEnergy.vue?vue&type=template&id=72989ba6&"
import script from "./ViewConsumptionEnergy.vue?vue&type=script&lang=js&"
export * from "./ViewConsumptionEnergy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports